module.exports = __webpack_public_path__ + "img/lang_black.1e3e7f21.svg";